import React from "react";
import "../style.css";
import OfferSlider from "./offer-slider";

const PaymentOfferSection = () => {
  return (
    <section className="payment-offer-section py-5">
      <div className="container">
        <div className="row g-0">
          {/* Left side - Payments Section */}
          <div className="col-lg-6 col-md-12">
            <div className="payment-section-wrapper">
              <div className="payment-content">
                <h2 className="payment-title">Many Types of Surveys</h2>
                <p className="payment-subtitle">Every survey you complete earns you rewards.</p>

                <div className="payment-grid">
                  <div className="payment-item">
                    <div className="payment-icon-circle">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect>
                        <polyline points="17,2 12,7 7,2"></polyline>
                      </svg>
                    </div>
                    <p className="payment-label">Quick Surveys</p>
                  </div>

                  <div className="payment-item">
                    <div className="payment-icon-circle">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 6v6l4 2"></path>
                      </svg>
                    </div>
                    <p className="payment-label">Instant Rewards</p>
                  </div>

                  <div className="payment-item">
                    <div className="payment-icon-circle">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                      </svg>
                    </div>
                    <p className="payment-label">Research Studies</p>
                  </div>

                  <div className="payment-item">
                    <div className="payment-icon-circle">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="8" y1="6" x2="21" y2="6"></line>
                        <line x1="8" y1="12" x2="21" y2="12"></line>
                        <line x1="8" y1="18" x2="21" y2="18"></line>
                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                      </svg>
                    </div>
                    <p className="payment-label">Referral Bonus</p>
                  </div>
                </div>
              </div>

              <div className="payment-image">
              
              </div>
            </div>
          </div>

          {/* Right side - Offers Section */}
          <div className="col-lg-6 col-md-12">
            <div className="offers-section-wrapper">
              <div className="offers-content">
                <h2 className="offers-title">Multiple Ways to Redeem</h2>
                <p className="offers-subtitle">
                  Cash out via UPI, bank transfer, or exciting gift cards.
                </p>
               
              </div>

              <div className="offers-banner">
              <OfferSlider />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentOfferSection;
